// extracted by mini-css-extract-plugin
var _1 = "AnnotationIcon-module__animateUploadProgressBarWidth--xPjFD";
var _2 = "AnnotationIcon-module__animatedBackground--Juo7r";
var _3 = "AnnotationIcon-module__container--ROeHq";
var _4 = "AnnotationIcon-module__hoverable--IPYRE";
var _5 = "AnnotationIcon-module__icon--UrDGJ";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "hoverable", _5 as "icon" }
